<div class="container">
  <h1>Neue Aktion</h1>
  <app-aktion-editor [aktion]="aktion" ></app-aktion-editor>
</div>
<div style="height:55px;"></div>
<div class="fixed-bottom secondaryBgColor d-flex justify-content-center justify-content-lg-end">
  <button class="btn pcButton m-2" (click)="saveAktion()">Speichern</button>
</div>
